/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
*/

// IP-NOTICE: MIXED
import { Component, OnInit, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { CookieService } from 'app/shared/services/cookie.service';
import { Router } from '@angular/router';
import { Constants } from 'app/core/models/constants';
import { ApiDependenciesService } from 'app/api/services/api-dependencies.service';
import { AuthService } from 'app/core/security/auth/auth.service';
import { AsideService } from 'app/layout/components/aside-container/aside.service';
import { ComponentItem } from 'app/shared/base/aside/component-item';
import { UserResetPasswordComponent } from 'app/layout/components/user-reset-password/user-reset-password.component';
import { UsersService } from 'app/modules/configuration/users/user-management/services/users.service';
import { HeaderService } from '../services/header.service';
import { environment } from 'environments/environment';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false,
})
export class HeaderComponent implements OnInit, OnDestroy {
  loggedInUserName: string;
  loggedInFullName: string;
  isOnline: boolean;

  @Input() menuOpen = false;

  @Output() toggleMenuEvent = new EventEmitter();

  constructor(
    protected usersService: UsersService,
    private cookieService: CookieService,
    private router: Router,
    private apiDependencies: ApiDependenciesService,
    private auth: AuthService,
    private asideService: AsideService,
    public headerService: HeaderService,
  ) {

  }

  ngOnInit() {
    this.usersService.ensurePermissions().then(() => {});
    this.loggedInUserName = this.cookieService.getLoggedInUserName();
    this.loggedInFullName = this.cookieService.getLoggedInFullName();
  }

  ngOnDestroy() {
  }

  logout(): void {
    localStorage.removeItem(Constants.LocalStorage.KeyAccessToken);
    localStorage.removeItem(Constants.LocalStorage.KeyRefreshToken);
    this.cookieService.delete(Constants.Cookies.KeyLoggedInUserId);
    this.cookieService.delete(Constants.Cookies.KeyLoggedInUserName);
    this.cookieService.delete(Constants.Cookies.KeyLoggedInFullName);
    this.cookieService.delete(Constants.Cookies.KeyOrganiserId);
    this.router.navigateByUrl('/login');
  }

  resetPassword(): void {
    const cookieValue = this.apiDependencies.cookieService.get(Constants.Cookies.KeyLoggedInUserId);
    const loggedInUerId = +cookieValue;
    const userId: number = this.auth.loggedInUserId && this.auth.loggedInUserId !== -1 ? this.auth.loggedInUserId : loggedInUerId;

    this.asideService.setComponent(new ComponentItem(UserResetPasswordComponent, { itemId: userId, invokedFromUserMenu: true }));
    this.asideService.open();
  }


  toggleMenu() {
    this.toggleMenuEvent.emit();
  }

  get showKioskLink(): boolean {
    return this.usersService.userPermissions.action.headerMenu.showKioskLink;
  }

  get showResetPassword(): boolean{
    return this.usersService.userPermissions.action.headerMenu.showResetPassword;
  }

  loadKiosk() {
    const organiserId: string = this.cookieService.getOrganiserId();
    const ticketShopUrl: string = environment.ticketShopUrl + '/ticket-shop/organisers/' + organiserId + '/kiosk-events';
    window.open(ticketShopUrl, '_blank');
  }
}
